module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07422_banner_800x600.edb69742.png";